import styles from './styles/footer-styles.module.css';

export default function FooterElement(){
    return <div className={styles.footer}>
        &copy; Juniper Robinson 2026 | All Rights Reserved
    </div>
}